<template>
  <div is="transition-group" name="fade" 
  class="business-hours-day-container ">
    <div v-for="({ open, close, id, location }, index) in hours" :key="id"
       class="mb-2" >
     <div class="row  my-1" role="rowgroup">
        <div class="col-lg-3 pr-0">
          <div class="pr-0 day" role="cell">
            <div v-if="showDay(index)" class="business-hours-label-day">
              {{ localization.days[day] }}
            </div>
          </div>
          <div class="toggle" role="cell">
            <ToggleButton
              v-if="showDay(index)"
              @change="
                toggleOpen();
                resetHours();
                runValidations();
              "
              :value="anyOpen"
              :sync="true"
              :labels="{
                checked: localization.switchOpen,
                unchecked: localization.switchClosed,
              }"
              :color="color"
              :width="switchWidth"
              :height="25"
              :font-size="12"
            />
          </div>
        </div>
        <transition name="fade">
          <div class="col-lg-2 hours open" role="cell" v-if="isOpenToday">
            <BusinessHoursSelect
              v-if="type === 'select'"
              :name="name"
              :input-num="inputNum('open', index)"
              :total-inputs="totalInputs"
              :day="day"
              :hours="hours"
              :time-increment="timeIncrement"
              :index="index"
              :selected-time="open"
              :localization="localization"
              :hour-format24="hourFormat24"
              @input-change="onChangeEventHandler('open', index, $event)"
            ></BusinessHoursSelect>
            <BusinessHoursDatalist
              v-if="type === 'datalist'"
              :name="name"
              :input-num="inputNum('open', index)"
              :total-inputs="totalInputs"
              :day="day"
              :hours="hours"
              :time-increment="timeIncrement"
              :index="index"
              :selected-time="open"
              :any-error="anyError(validations[index].open)"
              :localization="localization"
              :hour-format24="hourFormat24"
              @input-change="onChangeEventHandler('open', index, $event)"
            ></BusinessHoursDatalist>
          </div>
        </transition>
        <transition name="fade">
          <div class="col-lg-2 hours close" role="cell" v-if="isOpenToday">
            <BusinessHoursSelect
              v-if="type === 'select'"
              :name="name"
              :input-num="inputNum('close', index)"
              :total-inputs="totalInputs"
              :day="day"
              :hours="hours"
              :time-increment="timeIncrement"
              :index="index"
              :selected-time="close"
              :localization="localization"
              :hour-format24="hourFormat24"
              @input-change="onChangeEventHandler('close', index, $event)"
            ></BusinessHoursSelect>
            <BusinessHoursDatalist
              v-if="type === 'datalist'"
              :name="name"
              :input-num="inputNum('close', index)"
              :total-inputs="totalInputs"
              :day="day"
              :hours="hours"
              :time-increment="timeIncrement"
              :index="index"
              :any-error="anyError(validations[index].close)"
              :updated-validations="validations[index].close"
              :selected-time="close"
              :hour-format24="hourFormat24"
              :localization="localization"
              @input-change="onChangeEventHandler('close', index, $event)"
            ></BusinessHoursDatalist>
          </div>
        </transition>

        <div class="col-lg-3 location" role="cell" v-if="isOpenToday">
          <LocationsSelect
              :name="name"
            :total-inputs="totalInputs"
            :day="day"
            :hours="hours"
            :time-increment="timeIncrement"
            :index="index"
            :selected-time="location"
            :hour-format24="hourFormat24"
            :localization="localization"
            @input-change="onChangeLocation(index, $event)"
          ></LocationsSelect>

          <!-- <select  :name="location" class="form-control"   :day="day"
              :hours="hours"
              :index="index"
              v-model="location"
          @change="onChangeLocation(index,$event)">
            <option value="">Select location </option>
            <option
              v-for="location in locations"
              :key="location.code"
              :value="location.code"
              class="testoption"
            >
              {{ location.label }}
            </option>
          </select> -->
          <!-- <v-select
              :options="locations"
              name="location"
              title="location"
              v-model="location"
              placeholder="Select location"
            ></v-select -->
        </div>
        <div class="col-lg-1 remove" role="cell" v-if="isOpenToday">
          <button
            type="button"
            class="font-awesome-button"
            v-if="showRemoveButton()"
            @click="removeRow(index)"
          >
            <font-awesome-icon icon="fa-times" class="fa-md" />
          </button>
        </div>
        <div class="col-lg-1 add" role="cell" v-if="isOpenToday">
          <button
            type="button"
            :style="{ color: color }"
            class="add-hours"
            v-if="showAddButton(index)"
            @click="addRow()"
          >
            <font-awesome-icon icon=" fa-circle-plus" class="fa-xl" />
          </button>
        </div>
        
      </div>
      <ul class="time-errors" v-if="validations[index].anyErrors">
        <li
          v-for="{ whichTime, error } in activeErrors(index)"
          :key="whichTime + '.' + error"
        >
          {{ errorMessage(whichTime, error) }}
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import BusinessHoursSelect from "./BusinessHoursSelect.vue";
import BusinessHoursDatalist from "./BusinessHoursDatalist.vue";
import LocationsSelect from "./LocationsSelectDoomYoga.vue";
import { ToggleButton } from "vue-js-toggle-button";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { helperMixin } from "../../mixins/helperMixin";
import { validationMixin } from "../../mixins/validationMixin";
import uniqid from "uniqid";
import $ from "jquery";
export default {
  name: "BusinessHoursDay",
  components: {
    BusinessHoursSelect,
    BusinessHoursDatalist,
    ToggleButton,
    FontAwesomeIcon,
    LocationsSelect,
  },
  mixins: [helperMixin, validationMixin],
  props: {
    day: {
      type: String,
      required: true,
    },
    hours: {
      type: Array,
      required: true,
    },
    name: {
      type: String,
      required: true,
    },
    timeIncrement: {
      type: Number,
      required: true,
    },
    type: {
      type: String,
      required: true,
    },
    color: {
      type: String,
      required: true,
    },
    localization: {
      type: Object,
    },
    switchWidth: {
      type: Number,
    },
    hourFormat24: {
      type: Boolean,
    },
    locations: {
      type: Array,
      required: true,
    },
  },
  computed: {
    totalInputs: function () {
      return this.hours.length * 2;
    },
    isOpenToday: function () {
      return this.hours[0].isOpen;
    },
    anyOpen: function () {
      return this.hours.some((hour) => {
        return hour.isOpen === true;
      });
    },
  },
  directives: {
    visible: function (el, binding) {
      el.style.visibility = binding.value ? "visible" : "hidden";
    },
  },
  methods: {
    onChangeLocation(index, value) {
      console.log("change loc ", index, value);
      this.hours[index]["location"] = value;
    },
    onChangeEventHandler: function (whichTime, index, value) {
      console.log("change time ", whichTime, index, value);
      value = this.backendInputFormat(value);

      if (value == "24hrs") {
        this.hours.splice(1);
        this.hours[0].open = this.hours[0].close = value;
        this.runValidations();
        this.updateHours();
        return;
      }

      if (
        (this.hours[index].open == "24hrs" ||
          this.hours[index].close == "24hrs") &&
        value == ""
      ) {
        this.hours[index].open = this.hours[index].close = value;
        this.runValidations();
        this.updateHours();
        return;
      }

      if (
        !this.onlyOneRow(this.hours) &&
        value === "" &&
        ((whichTime === "open" && this.hours[index].close === "") ||
          (whichTime === "close" && this.hours[index].open === ""))
      ) {
        this.removeRow(index);
        this.runValidations();
        this.updateHours();
        return;
      }

      this.hours[index][whichTime] = value;
      this.runValidations();
      this.updateHours();
    },
    inputNum: function (whichTime, index) {
      if (whichTime === "open") {
        return index * 2 + 1;
      } else if (whichTime === "close") {
        return index * 2 + 2;
      }
    },
    toggleOpen: function () {
      this.hours[0].isOpen = this.hours[0].isOpen ? false : true;
    },
    resetHours: function () {
      this.hours.splice(1);
      this.hours[0].open = this.hours[0].close = "";
      this.updateHours();
    },
    addRow: function () {
      this.hours.push({
        id: uniqid(),
        open: "",
        close: "",
        isOpen: true,
        location: "",
      });
      this.runValidations();
      this.updateHours();
    },
    removeRow: function (index) {
      this.hours.splice(index, 1);
      this.runValidations();
      this.updateHours();
    },
    showDay: function (index) {
      return index > 0 ? false : true;
    },
    showRemoveButton: function () {
      return this.hours.length > 1 ? true : false;
    },
    showAddButton: function (index) {
      return this.hours.length === index + 1 &&
        // this.hours[index].open !== "" &&
        // this.hours[index].close !== "" &&
        this.hours[index].open !== "24hrs" &&
        this.hours[index].close !== "24hrs" &&
        !(
          this.type === "select" &&
          this.timeIncrement === 15 &&
          this.hours[index].close === "2345"
        ) &&
        !(
          this.type === "select" &&
          this.timeIncrement === 30 &&
          this.hours[index].close === "2330"
        ) &&
        !(
          this.type === "select" &&
          this.timeIncrement === 60 &&
          this.hours[index].close === "2300"
        ) &&
        this.hours[index].close !== "2400" &&
        this.validations[index].anyErrors === false
        ? true
        : false;
    },
    updateHours: function () {
      const updatedHours = { [this.day]: this.hours };
      this.$emit("hours-change", updatedHours);
    },
  },
};
</script>

<style  scoped>
.flex-table {
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  margin: 0.75em 0;
  height: 45px;
  width: 100%;
}

.flex-row {
  width: 20%;
}

.flex-row input,
.flex-row select {
  margin: 1px;
  padding: 3px 5px;
  width: 110px;
  height: 28px;
  font-size: 14px;
  line-height: 28px;
  vertical-align: middle;
  border: 1px solid #d5d5d5;
  box-sizing: border-box;
}

.flex-row.day {
  width: 130px;
}

.flex-row.hours {
  width: 110px;
}

.flex-row.dash {
  margin: 0 7px;
  width: 4px;
}

.row-container {
  flex-direction: column;
}

.row {
  flex-direction: row;
}

.remove {
  display: flex;
  justify-content: center;
  width: 50px;
}

label.vue-js-switch {
  margin-bottom: 0;
}

button.add-hours,
button.font-awesome-button {
  height: 30px;
  background-color: transparent;
  border-color: transparent;
  border-style: none;
  border-width: 0;
  padding: 0;
  cursor: pointer;
}

button.add-hours:focus,
button.font-awesome-button:focus {
  outline: none;
}

button.font-awesome-button {
  width: 30px;
  font-size: 24px;
}

button.add-hours {
  font-size: 14px;
  font-weight: bold;
}

.fa-times {
  color: #3d4852;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s ease;
}

.fade-enter,
.fade-leave-to
  /* .component-fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

.time-errors {
  margin: 0;
  padding: 0;
  font-size: 15px;
  font-weight: 400;
  color: #e3342f;
  list-style: none;
}

.time-errors li {
  margin-bottom: 6px;
}
</style>



// WEBPACK FOOTER //
// src/components/vue-business-hours/BusinessHoursDayDoomYoga.vue